"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const ui_1 = require("@completeanatomy/ui");
const focus_trap_react_1 = require("focus-trap-react");
const react_1 = require("react");
const react_transition_group_1 = require("react-transition-group");
const styled_components_1 = __importStar(require("styled-components"));
const ANIMATION_TIME = 700;
const deviceBreakpointSize = 899;
function SlideOutPanel({ isOpen, children, setCurrentTab, currentTab, }) {
    const containerRef = (0, react_1.useRef)(null);
    const isLower = (0, ui_1.useScreenBreakpoint)(deviceBreakpointSize);
    const handleEnter = () => {
        document.body.style.overflow = 'hidden';
    };
    const handleEntered = () => {
        if (isOpen && containerRef.current) {
            const focusTarget = containerRef.current.querySelector('#selected-spot');
            if (focusTarget) {
                focusTarget.focus();
            }
        }
    };
    const handleExited = () => {
        if (currentTab !== bridge_schema_1.InfoBoxTabType.Isolate) {
            setCurrentTab(bridge_schema_1.InfoBoxTabType.None);
        }
        document.body.style.overflow = '';
    };
    return ((0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { in: isOpen, timeout: ANIMATION_TIME, classNames: "slide", unmountOnExit: true, appear: true, onEnter: handleEnter, onEntered: handleEntered, onExited: handleExited, "data-e2e": 'SlideOutPanel_CSSTransition', children: (0, jsx_runtime_1.jsx)(focus_trap_react_1.FocusTrap, { focusTrapOptions: {
                allowOutsideClick: true,
                fallbackFocus: () => containerRef.current || document.body,
            }, active: !isLower && isOpen, "data-e2e": 'SlideOutPanel_FocusTrap', children: (0, jsx_runtime_1.jsx)(Container, { ref: containerRef, role: "dialog", "aria-modal": "true", "data-e2e": 'SlideOutPanel_Container', children: children }) }) }));
}
const Container = styled_components_1.default.div `
  position: absolute;
  top: 8px;
  left: 216px;
  width: 348px;
  height: calc(100vh - 140px);
  padding: 16px 8px;
  display: flex;
  flex-direction: column;
  border-radius: 0px;
  box-sizing: border-box;
  background: ${props => props.theme.grasshopper.infoBox.SlideOutPanelBackground};
  color: ${props => props.theme.white};
  z-index: 0;

  ${ui_1.deviceMainScreen.tablet((0, styled_components_1.css) `
    bottom: 0;
    max-height: 40vh;
    background: ${props => props.theme.grasshopper.infoBox.slideOutPanelMobileBackground};
  `)};

  &.slide-enter {
    transform: translateX(-100%);
  }
  &.slide-enter-active {
    transform: translateX(0);
    transition: transform ${ANIMATION_TIME}ms ease-in-out;
  }
  &.slide-exit {
    transform: translateX(0);
  }
  &.slide-exit-active {
    transform: translateX(-100%);
    transition: transform ${ANIMATION_TIME}ms ease-in-out;
  }

  ${ui_1.deviceMainScreen.tablet((0, styled_components_1.css) `
    width: 100%;
    height: 40vh;
    left: 0;
    bottom: 0;
    top: auto;

    &.slide-appear,
    &.slide-enter {
      transform: translateY(100%);
    }

    &.slide-appear-active,
    &.slide-enter-active {
      transform: translateY(0);
      transition: transform ${ANIMATION_TIME}ms ease-in-out;
    }

    &.slide-exit {
      transform: translateY(0);
    }

    &.slide-exit-active {
      transform: translateY(100%);
      transition: transform ${ANIMATION_TIME}ms ease-in-out;
    }
  `)};
`;
exports.default = SlideOutPanel;
